"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Socials = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const utils_1 = require("@obvio/utils");
const PanelLayout_1 = require("../MenuPanel/PanelLayout");
const Links = (0, app_1.styled)(ui_1.Stack) `
  align-items: center;
`;
const Divider = app_1.styled.div `
  height: 1px;
  width: 0.5rem;
  background: ${(theme) => theme.stroke};
`;
function Socials({ additional, socials }) {
    return ((0, jsx_runtime_1.jsxs)(PanelLayout_1.PanelLayout, { children: [(0, jsx_runtime_1.jsx)(Links, Object.assign({ divider: Divider }, { children: Object.entries(socials).map(([social, value]) => ((0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: value }, { children: (0, utils_1.capitalize)(social) }), value))) })), additional !== null && additional !== void 0 ? additional : null] }));
}
exports.Socials = Socials;
